import React, {
  useState,
  useEffect,
  useMemo,
  Fragment,
  useRef,
  useCallback,
  useContext,
} from "react";
import api from "../api/axios";
import "./Scss/ContactStyles.scss?v=1.1.3";
// Animations
import {
  Alert,
  Autocomplete,
  Collapse,
  Fade,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
  Button,
} from "@mui/material";
import ReactPaginate from "react-paginate";
// DATEPICKER
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

// DATEPICKER
// MANUAL COMPONENTS
import Table from "../Components/Common/Table/Table";
// FUNCTIONS
import { CircularProgress, LinearProgress } from "@mui/material/";

import { CommonSubHeader, handleDates } from "../Components/helpers/Helpers";
import LoadingPage from "../Components/Common/Loading/LoadingPage";
import { RenderCell } from "../Components/Common/Table/RenderCell";
import {
  CleaningServices,
  Delete,
  KeyboardArrowDown,
  KeyboardArrowUp,
  PersonAdd,
  Search,
  Visibility,
} from "@mui/icons-material";
import TableActions from "../Components/Common/Table/TableActions";
import { CustomButtonPlusIcon } from "../Components/Common/Design/CustomButtonPlusIcon";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { PermissionContext } from "../Components/Context/Context";
import { hasPermission } from "../Components/Context/helpers/permissions";
import Unauthorized from "../Components/Common/Design/Unauthorized";
import { useNavigate } from "react-router-dom";
import { Box, height, padding, textAlign } from "@mui/system";

function Contactos(props) {
  // SweetAlert
  const Swal = require("sweetalert2");
  const hasMounted = useRef(false);
  const [showFilters, setShowFilters] = useState(true);

  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  const handleSort = (column, direction) => {
    console.log(column, direction);
    setSortColumn(column);
    setSortDirection(direction);
    setPagePressed(1); // reinicia paginación
  };

  const { can } = useContext(PermissionContext);
  const hasPermission = can("contacts", "view");
  const navigate = useNavigate();

  //Resultados por pagina.
  const [contact, setContact] = useState([]);
  const [urlSetted, setUrlSetted] = useState("");
  const [objPerPage, setObjPerPage] = useState(10);
  const [totalPagesNumber, setTotalPagesNumber] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [pagePressed, setPagePressed] = useState(1);
  const [flag, setFlag] = useState(false);
  const [dataNoResults, setDataNoResults] = useState(false);
  const [search, setSearch] = useState(false);

  const [stateDelete, setStateDelete] = useState(false);

  const [rawCaseTypes, setRawCaseTypes] = useState([]);
  const [rawCompanies, setRawCompanies] = useState([]);
  const [rawLawyers, setRawLawyers] = useState([]);
  const [rawAssociations, setRawAssociations] = useState([]);

  // Columns data input filters
  const [assignTo, setAssignTo] = useState({
    name: "Seleccionar",
    surname: "",
  });
  const [caseTypeId, setCaseTypeId] = useState({
    case_type: "Seleccionar",
    id: 0,
  });
  const [statusId, setStatusId] = useState({ id: 0, nombre: "Seleccionar" });
  const [companyId, setCompanyId] = useState({
    company_name: "Seleccionar",
    id: 0,
  });
  const [asociationId, setAsociationId] = useState({
    asoc_name: "Seleccionar",
    id: 0,
  });

  // MANEJO DE FILTROS
  const [queryName, setQueryName] = useState(false);
  const [querySurname, setQuerySurname] = useState(false);
  const [queryPhone, setQueryPhone] = useState(false);
  const [queryEmail, setQueryEmail] = useState(false);
  const [queryProvince, setQueryProvince] = useState(false);

  const [provinceFilter, setProvinceFilter] = useState("");
  const [nameFilter, setNameFilter] = useState("");
  const [surnameFilter, setSurnameFilter] = useState("");
  const [phoneFilter, setPhoneFilter] = useState("");
  const [emailFilter, setEmailFilter] = useState("");
  // MANEJO DE FILTROS

  // DATEPICKER
  const [dateInDefault, setDateInDefault] = useState();
  const [dateInFilter, setDateInFilter] = useState(0);
  const [dateUpdateDefault, setDateUpdateDefault] = useState();
  const [dateUpdateFilter, setDateUpdateFilter] = useState(0);
  const [dateFromRangeFilter, setDateFromRangeFilter] = useState(0);
  const [dateFromDefault, setDateFromDefault] = useState();
  const [dateToRangeFilter, setDateToRangeFilter] = useState(0);
  const [dateToDefault, setDateToDefault] = useState();
  // DATEPICKER

  // LISTAS PARA SELECTS FILTERS
  const [openOptionsCaseTypes, setOpenOptionsCaseTypes] = useState(false);
  const [openOptionsStatus, setOpenOptionsStatus] = useState(false);
  const [openOptionsChangeStatus, setOpenOptionsChangeStatus] = useState(false);
  const [openOptionsAsignTo, setOpenOptionsAsignTo] = useState(false);
  const [openOptionsCompanies, setOpenOptionsCompanies] = useState(false);
  const [openOptionsAsociations, setOpenOptionsAsociations] = useState(false);

  const [optionsCaseTypes, setOptionsCaseTypes] = useState([]);
  const [optionsStatus, setOptionsStatus] = useState([]);
  const [optionsChangeStatus, setOptionsChangeStatus] = useState([]);
  const [optionsAsignTo, setOptionsAsignTo] = useState([]);
  const [optionsCompanies, setOptionsCompanies] = useState([]);
  const [optionsAsociations, setOptionsAsociations] = useState([]);

  const loadingOptionsCaseTypes =
    openOptionsCaseTypes && optionsCaseTypes.length === 0;
  const loadingOptionsStatus = openOptionsStatus && optionsStatus.length === 0;
  const loadingOptionsChangeStatus =
    openOptionsChangeStatus && optionsChangeStatus.length === 0;
  const loadingOptionsAsignTo =
    openOptionsAsignTo && optionsAsignTo.length === 0;
  const loadingOptionsCompanies =
    openOptionsCompanies && optionsCompanies.length === 0;
  const loadingOptionsAsociations =
    openOptionsAsociations && optionsAsociations.length === 0;
  // LISTAS PARA SELECTS FILTERS

  /// Checkboxes
  const [deletedSuccess, setDeletedSuccess] = useState(false);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [contactNewState, setContactNewState] = useState(false);
  const [changeStateResponse, setChangeStateResponse] = useState(false);
  const [changeDone, setChangeDone] = useState(false);
  const [flagToChangeStateHidePaginator, setFlagToChangeStateHidePaginator] =
    useState(false);
  /// Checkboxes
  const [showStatusColumn, setShowStatusColumn] = useState(false); // Cambia a false para ocultar la columna de estado
  const isCompanySelected = companyId?.id && companyId.id !== 0;

  const scrollPosition = useRef(0);

  const getDataContacts = useCallback(async () => {
    setFlag(true);
    scrollPosition.current = window.scrollY;
    console.log(sortColumn, sortDirection);

    try {
      console.log(statusId);

      if (objPerPage >= 500) {
        Swal.fire({
          icon: "warning",
          title: "Carga de registros extensa",
          text: "Ha seleccionado un volumen elevado de registros. El proceso de carga puede tardar algunos segundos, le agradecemos su paciencia mientras se completan los archivos.",
          confirmButtonText: "Aceptar",
        });
      }

      const params = {
        page: pagePressed,
        objPerPage,
        caseType: caseTypeId?.id || 0,
        companySelected: companyId.id || 0,
        asociationSelected: asociationId.id || 0,
        assignedName: assignTo?.id ? assignTo?.name : "",
        assignedSurname: assignTo?.id ? assignTo?.surname : "",
        name: queryName || "",
        surname: querySurname || "",
        phone: queryPhone || "",
        email: queryEmail || "",
        province: queryProvince || "",
        dateIn: dateInFilter,
        date_update: dateUpdateFilter,
        dateInRange: dateFromRangeFilter,
        dateToRange: dateToRangeFilter,
        sortColumn,
        sortDirection,
      };

      if (statusId?.id || statusId.id == -1 || statusId.id == "-1") {
        params.contactStatus = statusId.id;
      }
      // Log para depuración
      console.log("Params enviados al backend:", params);

      const response = await api.post(
        process.env.REACT_APP_API_URL + `/contacts`,
        params,
      );

      console.log(response);
      const { status, contacts, cases_type, companies, associations, lawyers } =
        response.data;

      const contactsData = contacts.data;

      contactsData.forEach((contact) => {
        if (contact.lawyers_relation.id !== 0) {
          contact.lawyers_fullname = `${contact.lawyers_relation.name} ${contact.lawyers_relation.surname}`;
        }

        if (contact.assigned_relation.id !== 0) {
          contact.assigned_fullname = `${contact.assigned_relation.name} ${contact.assigned_relation.surname}`;
        }

        contact.status_name = getStatusName(contact.status);

        if (contact.name !== "" || contact.surname !== "") {
          contact.contact_fullname = `${contact.name} ${contact.surname}`;
        }
      });

      setRawCaseTypes(cases_type);
      setRawCompanies(companies);
      setRawLawyers(lawyers);
      setRawAssociations(associations);

      associations.unshift({ asoc_name: "Seleccionar", id: 0 });

      setOptionsAsociations(associations);

      setPageCount(contacts.last_page);
      setTotalPagesNumber(contacts.total);
      setContact(contacts.data);
      setFlag(false);
      setDataNoResults(contacts.total === 0);
    } catch (error) {
      console.error("ERROR AXIOS:", error);

      if (error.response) {
        console.error("STATUS:", error.response.status);
        console.error("DATA:", error.response.data);
        console.error("HEADERS:", error.response.headers);
      } else if (error.request) {
        console.error("NO RESPONSE:", error.request);
      } else {
        console.error("REQUEST ERROR:", error.message);
      }
    } finally {
      setFlag(false);

      // Restaurar scroll después de que la página termine de renderizar
      setTimeout(() => {
        window.scrollTo({ top: scrollPosition.current, behavior: "auto" });
      }, 0);
    }
  }, [
    pagePressed,
    objPerPage,
    search,
    changeDone,
    sortColumn,
    sortDirection,
    // caseTypeId,
    // statusId,
    // companyId,
    // asociationId,
    // assignTo,
    // queryName,
    // querySurname,
    // queryPhone,
    // queryEmail,
    // queryProvince,
    // dateInFilter,
    // dateFromRangeFilter,
    // dateToRangeFilter,
  ]);

  const handleFilterStates = () => {
    setCaseTypeId({ case_type: "Seleccionar", id: 0 });
    setCompanyId({ company_name: "Seleccionar", id: 0 });
    setAssignTo({ name: "Seleccionar", surname: "", id: 0 });
    setAsociationId({ asoc_name: "Seleccionar", id: 0 });
    setStatusId({ nombre: "Seleccionar", id: 0 });

    // MANEJO DE FILTROS
    setQueryName("");
    setQuerySurname("");
    setQueryPhone("");
    setQueryEmail("");
    setQueryProvince("");

    setProvinceFilter("");
    setNameFilter("");
    setSurnameFilter("");
    setPhoneFilter("");
    setEmailFilter("");
    // MANEJO DE FILTROS

    // // DATEPICKER
    setDateInDefault(null);
    setDateInFilter("");
    setDateFromRangeFilter("");
    setDateFromDefault(null);
    setDateToRangeFilter("");
    setDateToDefault(null);

    setSearch(!search);
  };

  const triggerSearchOnEnter = (event) => {
    if (event?.key === "Enter") {
      event.preventDefault();
      setSearch((prev) => !prev);
    }
  };

  // Función para obtener el nombre del estado
  const getStatusName = (status) => {
    const statusNames = {
      0: "Pte Llamada",
      1: "Llamado",
      2: "Cliente",
      3: "Cancelado",
    };
    return statusNames[status] || "";
  };

  // Función para establecer las opciones
  const setOptions = (casesTypes, companies, lawyers, associations) => {
    casesTypes.unshift({ case_type: "Seleccionar", id: 0 });
    companies.unshift({ company_name: "Seleccionar", id: 0 });
    lawyers.unshift({ name: "Seleccionar", surname: "" });
    associations.unshift({ asoc_name: "Seleccionar", id: 0 });

    const arrayToStatus = [
      { nombre: "Seleccionar", id: 0 },
      { nombre: "Pte Llamada", id: -1 },
      { nombre: "Llamado", id: 1 },
      { nombre: "Cliente", id: 2 },
      { nombre: "Cancelado", id: 3 },
    ];

    // FILTRADO SOLO SI HAY EMPRESA
    let filteredCaseTypes = casesTypes;
    let filteredLawyers = lawyers;
    let filteredAssociations = associations;

    if (isCompanySelected) {
      filteredCaseTypes = casesTypes.filter(
        (c) => c.id === 0 || c.company_id === companyId.id,
      );

      filteredLawyers = lawyers.filter(
        (l) => !l.id || l.company_id === companyId.id,
      );

      filteredAssociations = associations.filter(
        (a) => a.id === 0 || a.company_id === companyId.id,
      );
    }

    setOptionsAsignTo(filteredLawyers);
    setOptionsCaseTypes(filteredCaseTypes);
    setOptionsCompanies(companies);
    setOptionsAsociations(filteredAssociations);
    setOptionsStatus(arrayToStatus);
    setOptionsChangeStatus(arrayToStatus);
  };

  const handleChangeDateIn = (newValue) => {
    // console.log(newValue); // Verifica si esto es un objeto dayjs
    if (newValue && dayjs.isDayjs(newValue)) {
      // Convierte el objeto dayjs a un string
      const formattedDate = newValue?.format("YYYY-MM-DD 00:00:00");
      setDateInDefault(newValue); // Guarda solo la fecha como string
      setDateInFilter(formattedDate); // Guarda solo la fecha como string
    } else {
      setDateInFilter(null);
      console.error("El nuevo valor no es un objeto dayjs");
    }
  };

  const handleChangeDateUpdate = (newValue) => {
    // console.log(newValue); // Verifica si esto es un objeto dayjs
    if (newValue && dayjs.isDayjs(newValue)) {
      // Convierte el objeto dayjs a un string
      const formattedDate = newValue?.format("YYYY-MM-DD 00:00:00");
      setDateUpdateDefault(newValue); // Guarda solo la fecha como string
      setDateUpdateFilter(formattedDate); // Guarda solo la fecha como string
    } else {
      setDateUpdateFilter(null);
      console.error("El nuevo valor no es un objeto dayjs");
    }
  };

  const handleChangeDateFromRange = (dateFrom) => {
    // console.log(dateFrom); // Verifica si esto es un objeto dayjs
    if (dateFrom && dayjs.isDayjs(dateFrom)) {
      // Convierte el objeto dayjs a un string
      const formattedDate = dateFrom.format("YYYY-MM-DD 00:00:00");
      setDateFromDefault(dateFrom); // Guarda solo la fecha como string
      setDateFromRangeFilter(formattedDate); // Guarda solo la fecha como string
    } else {
      setDateFromRangeFilter(null);
    }
  };

  const handleChangeDateToRange = (dateTo) => {
    // console.log(dateTo); // Verifica si esto es un objeto dayjs
    if (dateTo && dayjs.isDayjs(dateTo)) {
      // Convierte el objeto dayjs a un string
      const formattedDate = dateTo.format("YYYY-MM-DD 23:59:59");
      setDateToDefault(dateTo); // Guarda solo la fecha como string
      setDateToRangeFilter(formattedDate); // Guarda solo la fecha como string
    } else {
      setDateToRangeFilter(null);
    }
  };

  const handlePageClick = (event) => {
    console.log(event.selected);
    setPagePressed(event.selected + 1);
  };

  useEffect(() => {
    if (!hasPermission) {
      return;
    }

    getDataContacts();
  }, [getDataContacts]);

  // FILTERS

  // SELECTS
  useEffect(() => {
    let activeOptionsCaseTypes = true;
    if (!loadingOptionsCaseTypes) {
      return undefined;
    }
    setTimeout(() => {
      if (activeOptionsCaseTypes) {
        setOptionsCaseTypes([...optionsCaseTypes]);
      }
    }, "200");
  }, [loadingOptionsCaseTypes]);

  useEffect(() => {
    let activeOptionsStatus = true;
    if (!loadingOptionsStatus) {
      return undefined;
    }
    setTimeout(() => {
      if (activeOptionsStatus) {
        setOptionsStatus([...optionsStatus]);
      }
    }, "200");
  }, [loadingOptionsStatus]);

  useEffect(() => {
    let activeOptionsAsignTo = true;
    if (!loadingOptionsAsignTo) {
      return undefined;
    }
    setTimeout(() => {
      if (activeOptionsAsignTo) {
        setOptionsAsignTo([...optionsAsignTo]);
      }
    }, "200");
  }, [loadingOptionsAsignTo]);

  useEffect(() => {
    let activeOptionsCompanies = true;
    if (!loadingOptionsCompanies) return undefined;

    setTimeout(() => {
      if (activeOptionsCompanies) {
        setOptionsCompanies([...optionsCompanies]); // <- usar optionsCompanies, NO openOptionsCompanies
      }
    }, 200);
  }, [loadingOptionsCompanies]);

  useEffect(() => {
    let activeOptionsAsociations = true;
    if (!loadingOptionsAsociations) {
      return undefined;
    }
    setTimeout(() => {
      if (activeOptionsAsociations) {
        setOptionsAsociations([...optionsAsociations]);
      }
    }, "200");
  }, [loadingOptionsAsociations]);

  useEffect(() => {
    if (!isCompanySelected) {
      setCaseTypeId({ case_type: "Seleccionar", id: 0 });
      setAssignTo({ name: "Seleccionar", surname: "", id: 0 });
      // setAsociationId({ asoc_name: "Seleccionar", id: 0 });
    }
  }, [companyId]);

  useEffect(() => {
    if (!rawCaseTypes.length) return;

    let casesTypes = [...rawCaseTypes];
    let companies = [...rawCompanies];
    let lawyers = [...rawLawyers];
    // let associations = [...rawAssociations];

    // Agregar opción "Seleccionar"
    casesTypes.unshift({ case_type: "Seleccionar", id: 0 });
    companies.unshift({ company_name: "Seleccionar", id: 0 });
    lawyers.unshift({ name: "Seleccionar", surname: "", id: 0 });

    if (isCompanySelected) {
      casesTypes = casesTypes.filter(
        (c) => c.id === 0 || c.company_id === companyId.id,
      );

      lawyers = lawyers.filter(
        (l) => l.id === 0 || l.company_id === companyId.id,
      );

      // associations = associations.filter(
      //   (a) => a.id === 0 || a.company_id === companyId.id,
      // );
    }

    const arrayToStatus = [
      { nombre: "Seleccionar", id: 0 },
      { nombre: "Pte Llamada", id: -1 },
      { nombre: "Llamado", id: 1 },
      { nombre: "Cliente", id: 2 },
      { nombre: "Cancelado", id: 3 },
    ];

    setOptionsCaseTypes(casesTypes);
    setOptionsCompanies(companies);
    setOptionsAsignTo(lawyers);
    setOptionsStatus(arrayToStatus);
    setOptionsChangeStatus(arrayToStatus);
  }, [
    companyId,
    rawCaseTypes,
    rawCompanies,
    rawLawyers,
    // rawAssociations
  ]);

  // END SELECTS

  const renderStatus = (estado) => {
    switch (estado) {
      case 0:
        return "Pte. Llamada";
      case 1:
        return "Llamado";
      case 2:
        return "Cliente";
      case 3:
        return "Cancelado";
      default:
        return "Sin asignar";
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: `LISTA DE CONTACTOS`,
        columns: [
          {
            Header: "Asignado a",
            accessor: "assigned_fullname",
            sortField: "lawyer",
            minWidth: 250,
            Cell: ({ row, value }) => (
              <Box
                sx={{
                  justifyContent: "left",
                  textAlign: "left",
                }}
              >
                <Button
                  component="a"
                  href={`/contactos/ver?id=${row?.original?.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  startIcon={<Visibility />}
                  variant="text"
                  sx={{
                    textTransform: "none",
                    justifyContent: "center",
                    fontSize: "inherit",
                    paddingLeft: "30px",
                    minWidth: 0,
                    "& .MuiButton-startIcon": { fontSize: "inherit" },
                    "&:hover": { backgroundColor: "transparent" },
                  }}
                >
                  <RenderCell value={value} defaultValue="Sin asignar" blank />
                </Button>
              </Box>
            ),
          },
          {
            Header: "Fecha de Entrada",
            sortField: "date_in",
            accessor: "date_in",
            width: 140,
            maxWidth: 200,
            minWidth: 180,
            Cell: ({ row, value }) => (
              <RenderCell value={value} dateFlag={true} />
            ),
          },
          {
            Header: "Tipo de caso",
            sortField: "case_type",
            accessor: "types_relation.case_type",
            width: 140,
            maxWidth: 200,
            minWidth: 140,
            Cell: ({ row, value }) => (
              <RenderCell value={value} dateFlag={true} />
            ),
          },
          {
            Header: "Actualizado",
            sortField: "date_update",
            accessor: "date_update",
            width: 140,
            maxWidth: 200,
            minWidth: 140,
            Cell: ({ row, value }) => (
              <RenderCell value={value} dateFlag={true} />
            ),
          },
          {
            Header: "Estado",
            sortField: "status",
            accessor: "status",
            width: 85,
            maxWidth: 200,
            minWidth: 110,
            Cell: ({ row }) => (
              <div className="centerContent">
                {renderStatus(row.original.status)}
              </div>
            ),
          },
          {
            Header: "Empresa",
            sortField: "company_id",
            accessor: "company_relation.company_name",
            minWidth: 130,
            Cell: ({ row, value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Asociación",
            accessor: "asociations_relation.asoc_name",
            sortField: "asoc_name",
            width: 300,
            minWidth: 150,
            Cell: ({ row, value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Provincia",
            sortField: "province",
            accessor: "province",
            width: 130,
            maxWidth: 200,
            minWidth: 130,
            Cell: ({ row, value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Nombre y Apellidos",
            sortField: "name",
            accessor: "contact_fullname",
            width: 166,
            maxWidth: 200,
            minWidth: 200,
            Cell: ({ row, value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Teléfono",
            sortField: "phone",
            accessor: "phone",
            width: 150,
            maxWidth: 200,
            minWidth: 150,
            Cell: ({ row, value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Email",
            sortField: "email",
            accessor: "email",
            width: 174,
            maxWidth: 200,
            minWidth: 174,
            Cell: ({ row, value }) => (
              <RenderCell value={value} defaultValue="Sin asignar" />
            ),
          },
          {
            Header: "Acciones",
            accessor: "id",
            minWidth: 174,
            Cell: ({ value }) => (
              <TableActions
                rute={"contactos"}
                value={value}
                showView
                showEdit
                showDelete
                module={"contacts"}
                apiRute={"contacts"}
                setChangeDone={setChangeDone}
                changeDone={changeDone}
              />
            ),
          },
        ],
      },
    ],
    [],
  );

  useEffect(() => {
    const hasSelectedRows = selectedRowIds.length > 0;
    setFlagToChangeStateHidePaginator((prev) =>
      prev === hasSelectedRows ? prev : hasSelectedRows,
    );
  }, [selectedRowIds.length]);

  useEffect(() => {
    if (pagePressed > pageCount) {
      setPagePressed(1);
    }
  }, [pageCount]);

  const normalizeSelectedContactIds = (rows = []) =>
    (Array.isArray(rows) ? rows : [])
      .map((row) => (typeof row === "object" ? row?.id : row))
      .filter((id) => id !== undefined && id !== null && id !== "");

  // NEW STATE
  const handleCheckBoxesToChangeState = async (val) => {
    const valuesSelected = normalizeSelectedContactIds(selectedRowIds);

    if (
      !valuesSelected ||
      valuesSelected === "" ||
      valuesSelected === 0 ||
      valuesSelected.length === 0
    ) {
      Swal.fire(
        "¡Error!",
        "No hay contactos seleccionados para actualizar.",
        "warning",
      );
      return;
    }
    if (contactNewState === 0 || contactNewState === false || contactNewState === undefined || contactNewState === null || contactNewState === "") {
      Swal.fire(
        "¡Error!",
        "Debes seleccionar un estado antes de guardar los cambios.",
        "warning",
      );
      return;
    }

    if (val == "changeStatus") {
      const queryUrl = `${process.env.REACT_APP_API_URL}/contacts/updatecontactstate`;

      try {
        const result = await Swal.fire({
          icon: "warning",
          title: "¿Desea guardar los cambios?",
          html: `Deseas cambiar el estado de <strong>${valuesSelected.length}</strong> registros?`,
          showDenyButton: true,
          confirmButtonColor: "#1ab394",
          cancelButtonColor: "#d33",
          reverseButtons: true,
          confirmButtonText: "Guardar",
          denyButtonText: "Cancelar",
        });

        if (result.isConfirmed) {
          Swal.fire({
            title: "Guardando cambios...",
            text: "Estamos actualizando el estado de los contactos seleccionados.",
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          try {
            const response = await api.post(queryUrl, {
              contactIds: JSON.stringify(valuesSelected),
              contactNewState: contactNewState,
            });

            if (response.data.response > 0) {
              setChangeStateResponse(!changeStateResponse);
              setFlagToChangeStateHidePaginator(false);
              Swal.fire({
                title: "¡Guardado!",
                text: "El estado de los contactos se actualizó correctamente.",
                icon: "success",
                confirmButtonColor: "#1ab394",
                confirmButtonText: "Continuar",
              }).then(() => {
                setSearch((prev) => !prev);
              });
            } else {
              Swal.fire({
                title:
                  "¡No se han registrado cambios o ha seleccionado el mismo estado!",
                icon: "error",
                confirmButtonText: "Ok",
                confirmButtonColor: "#1ab394",
              });
            }
          } catch (error) {
            console.error("Error al actualizar el estado de los contactos:", error);
            Swal.fire({
              title: "¡Error!",
              text: "Ha ocurrido un problema al intentar actualizar el estado.",
              icon: "error",
              confirmButtonText: "Ok",
              confirmButtonColor: "#1ab394",
            });
          }
        } else if (result.isDenied) {
          Swal.fire({
            title: "¡Los cambios no han sido guardados!",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#1ab394",
          });
        }
      } catch (error) {
        console.error("Error al actualizar el estado de los contactos:", error);
        Swal.fire({
          title: "¡Error!",
          text: "Ha ocurrido un problema al intentar actualizar el estado.",
          icon: "error",
          confirmButtonText: "Ok",
          confirmButtonColor: "#1ab394",
        });
      }
    } else if (val == "delete") {
    }
  };

  const hasValidSelectedStatus = [-1, 1, 2, 3].includes(Number(contactNewState));
  const getStatusOptionValue = () => {
    if (!hasValidSelectedStatus) return null;

    return (
      optionsChangeStatus.find(
        (option) => Number(option?.id) === Number(contactNewState),
      ) || null
    );
  };

  const ChangeStatusBlock = (
    <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
      <Autocomplete
        className="changeStatusId "
        size="small"
        value={getStatusOptionValue()}
        sx={{
          width: 220,
          "& .MuiInputBase-root": {
            height: "34px !important",
          },
          backgroundColor: "white",
        }}
        onChange={(e, value) => {
          const nextValue = value?.id;

          if (
            nextValue !== undefined &&
            nextValue !== null &&
            Number(nextValue) !== 0
          ) {
            setContactNewState(Number(nextValue));
            setShowStatusColumn(true);
          } else {
            setContactNewState(null);
            setShowStatusColumn(false);
          }
        }}
        open={openOptionsChangeStatus}
        onOpen={() => setOpenOptionsChangeStatus(true)}
        onClose={() => setOpenOptionsChangeStatus(false)}
        isOptionEqualToValue={(o, v) => Number(o.id) === Number(v.id)}
        getOptionLabel={(o) => o.nombre || ""}
        options={optionsChangeStatus}
        loading={loadingOptionsChangeStatus}
        renderInput={(params) => (
          <TextField {...params} label="Cambiar estado" size="small" />
        )}
      />

      <Button
        onClick={() => handleCheckBoxesToChangeState("changeStatus")}
        variant="outlined"
        size="small"
        disabled={!hasValidSelectedStatus || selectedRowIds.length === 0}
        sx={{
          height: "33px",
          position: "relative",
          opacity: !hasValidSelectedStatus || selectedRowIds.length === 0 ? 0.6 : 1,
        }}
        color="primary"
      >
        Cambiar
        {selectedRowIds.length > 0 && (
          <Box
            component="span"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: 20,
              height: 20,
              px: 0.8,
              ml: 1,
              borderRadius: "999px",
              backgroundColor: "#0d7bc8",
              color: "#fff",
              fontSize: "0.72rem",
              fontWeight: 700,
              lineHeight: 1,
            }}
          >
            {selectedRowIds.length}
          </Box>
        )}
      </Button>
    </div>
  );

  const filtersConfig = [
    // ========================
    // AUTOCOMPLETES
    // ========================
    {
      type: "autocomplete",
      grid: { xs: 4, md: 2 },
      label: "Asignado a",
      className: "asignToId",
      value: assignTo,
      setValue: (value) =>
        value
          ? setAssignTo({
              name: value?.name,
              surname: value?.surname,
              id: value?.id,
            })
          : null,
      open: openOptionsAsignTo,
      setOpen: setOpenOptionsAsignTo,
      options: optionsAsignTo,
      loading: loadingOptionsAsignTo,
      getOptionLabel: (option) =>
        `${option?.name || ""} ${option?.surname || ""}`,
      isOptionEqualToValue: (option, value) => option?.id === value?.id,
    },
    {
      type: "autocomplete",
      grid: { xs: 4, md: 2 },
      label: "Tipo de caso",
      className: "caseTypeId",
      value: {
        case_type: caseTypeId?.case_type || "Seleccionar",
        id: caseTypeId?.id || 0,
      },
      setValue: (value) => (value ? setCaseTypeId(value) : null),
      open: openOptionsCaseTypes,
      setOpen: setOpenOptionsCaseTypes,
      options: optionsCaseTypes,
      loading: loadingOptionsCaseTypes,
      getOptionLabel: (option) => option?.case_type || "",
      isOptionEqualToValue: (option, value) => option?.id === value?.id,
    },
    {
      type: "autocomplete",
      grid: { xs: 4, md: 2 },
      label: "Estado",
      className: "statusId",
      value: statusId ?? { nombre: "Seleccionar", id: 0 },
      setValue: (value) =>
        setStatusId(value || { nombre: "Seleccionar", id: 0 }),
      open: openOptionsStatus,
      setOpen: setOpenOptionsStatus,
      options: optionsStatus,
      loading: loadingOptionsStatus,
      getOptionLabel: (option) => option?.nombre || "",
      isOptionEqualToValue: (option, value) => option?.nombre === value?.nombre,
    },
    {
      type: "autocomplete",
      grid: { xs: 4, md: 2 },
      label: "Empresa",
      className: "companyId",
      value: {
        company_name: companyId?.company_name || "Seleccionar",
        id: companyId.id || 0,
      },
      setValue: (value) => (value ? setCompanyId(value) : null),
      open: openOptionsCompanies,
      setOpen: setOpenOptionsCompanies,
      options: optionsCompanies,
      loading: loadingOptionsCompanies,
      getOptionLabel: (option) => option?.company_name || "",
      isOptionEqualToValue: (option, value) => option?.id === value?.id,
    },
    {
      type: "autocomplete",
      grid: { xs: 4, md: 2 },
      label: "Asociaciones",
      className: "asociationsId",
      value: {
        asoc_name: asociationId?.asoc_name || "Seleccionar",
        id: asociationId.id || 0,
      },
      setValue: (value) => (value ? setAsociationId(value) : null),
      open: openOptionsAsociations,
      setOpen: setOpenOptionsAsociations,
      options: optionsAsociations,
      loading: loadingOptionsAsociations,
      getOptionLabel: (option) => option?.asoc_name || "",
      isOptionEqualToValue: (option, value) => option?.id === value?.id,
    },

    // ========================
    // DATE ÚNICOS
    // ========================
    {
      type: "date",
      grid: { xs: 4, md: 2 },
      label: "Fecha de entrada",
      value: dateInDefault ? dayjs(dateInDefault) : null,
      onChange: (value) => handleChangeDateIn(value),
    },
    {
      type: "date",
      grid: { xs: 4, md: 2 },
      label: "Actualizado",
      value: dateUpdateDefault ? dayjs(dateUpdateDefault) : null,
      onChange: (value) => handleChangeDateUpdate(value),
    },

    // ========================
    // TEXTFIELDS
    // ========================
    {
      type: "text",
      grid: { xs: 4, md: 2 },
      label: "Provincia",
      value: queryProvince,
      setValue: setQueryProvince,
    },
    {
      type: "text",
      grid: { xs: 4, md: 2 },
      label: "Nombre contacto",
      value: queryName,
      setValue: setQueryName,
    },
    {
      type: "text",
      grid: { xs: 4, md: 2 },
      label: "Apellido contacto",
      value: querySurname,
      setValue: setQuerySurname,
    },
    {
      type: "text",
      grid: { xs: 4, md: 2 },
      label: "Teléfono",
      value: queryPhone,
      setValue: setQueryPhone,
    },
    {
      type: "text",
      grid: { xs: 4, md: 2 },
      label: "Email",
      value: queryEmail,
      setValue: setQueryEmail,
    },

    // ========================
    // DATE RANGE (como bloque)
    // ========================
    {
      type: "dateRange",
      grid: { xs: 12, md: 8 },
      items: [
        {
          label: "Fecha entrada desde",
          value: dateFromDefault ? dayjs(dateFromDefault) : null,
          onChange: (date) => handleChangeDateFromRange(date),
          sx: {
            width: "50%",
            "& fieldset": {
              borderRight: "none",
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
              height: "36px",
            },
          },
          className: "rangeFilterDateLeft",
        },
        {
          label: "Fecha entrada hasta",
          value: dateToDefault ? dayjs(dateToDefault) : null,
          onChange: (date) => handleChangeDateToRange(date),
          sx: {
            width: "50%",
            "& fieldset": {
              borderLeft: "none",
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              height: "36px",
            },
          },
          className: "rangeFilterDateRight",
        },
      ],
    },

    // ========================
    // SELECT Nº REGISTROS
    // ========================
    {
      type: "select",
      grid: { xs: 4, md: 2 },
      sxGrid: {
        ml: { md: "auto" },
      },
      label: "Nº Registros",
      value: objPerPage,
      options: [10, 20, 30, 100, 200, 500, 1000, 2000],
      onChange: (e) => {
        setObjPerPage(Number(e.target.value));
        setPagePressed(1);
      },
    },
  ];

  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Contactos" />

      <div className="mainContainer">
        <div className="subMainContainer">
          {!hasPermission && <Unauthorized />}

          {hasPermission && (
            <Box
              sx={{
                position: "relative",
                background:
                  "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(240,253,250,0.96) 100%)",
                marginBottom: "33px",
                mx: "10px",
                borderRadius: "14px",
                border: "1px solid rgba(59, 130, 246, 0.12)",
                boxShadow: "0 8px 20px rgba(15, 23, 42, 0.04)",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 1,
                  px: { xs: 1.2, md: 1.6 },
                  py: 1,
                  background:
                    "linear-gradient(90deg, rgba(59,130,246,0.08) 0%, rgba(255,255,255,0.96) 68%)",
                  borderBottom: "1px solid rgba(59, 130, 246, 0.1)",
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 700,
                    color: "#0f3dbf",
                    letterSpacing: "0.03em",
                  }}
                >
                  Filtros de búsqueda
                </Typography>

                <Button
                  variant="outlined"
                  size="small"
                  onClick={() => setShowFilters(!showFilters)}
                  endIcon={
                    showFilters ? <KeyboardArrowUp /> : <KeyboardArrowDown />
                  }
                  sx={{
                    minWidth: { xs: "36px", sm: "156px" },
                    width: { xs: "36px", sm: "auto" },
                    height: "30px",
                    px: { xs: 0.25, sm: 1.2 },
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: "0.78rem",
                    borderColor: "rgba(59, 130, 246, 0.24)",
                    color: "#1e3a8a",
                    backgroundColor: "rgba(255,255,255,0.86)",
                    transition:
                      "all 220ms cubic-bezier(0.22,1,0.36,1), box-shadow 220ms cubic-bezier(0.22,1,0.36,1)",
                    "& .MuiButton-endIcon": {
                      marginLeft: { xs: 0, sm: 0.5 },
                      marginRight: 0,
                    },
                    "&:hover": {
                      borderColor: "rgba(59, 130, 246, 0.42)",
                      backgroundColor: "#ffffff",
                      boxShadow: "0 4px 12px rgba(59, 130, 246, 0.14)",
                    },
                  }}
                >
                  <Box
                    component="span"
                    sx={{ display: { xs: "none", sm: "inline" } }}
                  >
                    {showFilters ? "Ocultar filtros" : "Mostrar filtros"}
                  </Box>
                </Button>
              </Box>

              <Collapse in={showFilters} timeout={400}>
                <Grid
                  container
                  className="filtersContainer"
                  sx={{
                    px: { xs: 0.75, md: 1.15 },
                    py: 0.95,
                    rowGap: 0.05,
                    backgroundColor: "transparent",
                  }}
                >
                  {filtersConfig.map((field, i) => {
                    const commonInputSx = {
                      width: "100%",
                      "& .MuiInputBase-root": {
                        height: "34px !important",
                        display: "flex",
                        alignItems: "center",
                      },
                      "& .MuiInputBase-input": {
                        padding: "10px 14px",
                        display: "flex",
                        alignItems: "center",
                        height: "100%",
                        boxSizing: "border-box",
                      },

                      "& .css-80fbtk-MuiFormControl-root-MuiTextField-root .MuiFormLabel-root":
                        {
                          paddingBottom: "10px",
                        },
                    };

                    if (field.type === "autocomplete") {
                      const requiresCompany = [
                        "asignToId",
                        "caseTypeId",
                      ].includes(field.className);

                      const isDisabled =
                        flagToChangeStateHidePaginator ||
                        (requiresCompany && !isCompanySelected);

                      return (
                        <Grid key={i} item {...field.grid} sx={{ p: "4px" }}>
                          <Tooltip
                            title={
                              isDisabled
                                ? "Por favor seleccione una empresa para habilitar"
                                : ""
                            }
                            arrow
                            placement="top"
                          >
                            <span>
                              <Autocomplete
                                className={`${field.className}`}
                                sx={commonInputSx}
                                size="small"
                                value={field.value}
                                disabled={isDisabled}
                                onChange={(e, v) => field.setValue(v)}
                                open={field.open}
                                onOpen={() => field.setOpen(true)}
                                onClose={() => field.setOpen(false)}
                                options={field.options}
                                isOptionEqualToValue={
                                  field.isOptionEqualToValue
                                }
                                getOptionLabel={field.getOptionLabel}
                                loading={field.loading}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={field.label}
                                    onKeyDown={triggerSearchOnEnter}
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                        <>
                                          {field.loading && (
                                            <CircularProgress
                                              color="inherit"
                                              size={20}
                                            />
                                          )}
                                          {params.InputProps.endAdornment}
                                        </>
                                      ),
                                    }}
                                  />
                                )}
                              />
                            </span>
                          </Tooltip>
                        </Grid>
                      );
                    }

                    if (field.type === "date") {
                      return (
                        <Grid key={i} item {...field.grid} sx={{ p: "4px" }}>
                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale="es"
                          >
                            <DesktopDatePicker
                              disabled={flagToChangeStateHidePaginator}
                              className=""
                              renderInput={(props) => (
                                <TextField
                                  {...props}
                                  onKeyDown={triggerSearchOnEnter}
                                />
                              )}
                              label={field.label}
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  size: "small",
                                  sx: commonInputSx,
                                },
                              }}
                              onChange={field.onChange}
                              inputFormat="DD/MM/YYYY"
                              value={field.value}
                            />
                          </LocalizationProvider>
                        </Grid>
                      );
                    }

                    if (field.type === "text") {
                      return (
                        <Grid key={i} item {...field.grid} sx={{ p: "4px" }}>
                          <TextField
                            disabled={flagToChangeStateHidePaginator}
                            className=""
                            onChange={(e) => field.setValue(e.target.value)}
                            label={field.label}
                            variant="outlined"
                            autoComplete="new-password"
                            size="small"
                            sx={commonInputSx}
                            value={field.value || ""}
                            onKeyDown={triggerSearchOnEnter}
                          />
                        </Grid>
                      );
                    }

                    if (field.type === "dateRange") {
                      return (
                        <Grid key={i} item {...field.grid} sx={{ p: "4px" }}>
                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale="es"
                          >
                            {field.items.map((item, idx) => (
                              <DesktopDatePicker
                                key={idx}
                                sx={item.sx}
                                disabled={flagToChangeStateHidePaginator}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    className={item.className}
                                    style={{
                                      width: "50%",
                                    }}
                                    onKeyDown={triggerSearchOnEnter}
                                  />
                                )}
                                label={item.label}
                                value={item.value}
                                onChange={item.onChange}
                              />
                            ))}
                          </LocalizationProvider>
                        </Grid>
                      );
                    }

                    if (field.type === "select") {
                      return (
                        <Grid
                          key={i}
                          item
                          {...field.grid}
                          sx={{ ...field.sxGrid, p: "4px" }}
                        >
                          <FormControl
                            fullWidth
                            size="small"
                            sx={commonInputSx}
                            disabled={flagToChangeStateHidePaginator}
                          >
                            <InputLabel>{field.label}</InputLabel>
                            <Select
                              value={field.value}
                              label={field.label}
                              onChange={field.onChange}
                              sx={commonInputSx}
                            >
                              {field.options.map((num) => (
                                <MenuItem key={num} value={num}>
                                  {num}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      );
                    }

                    return null;
                  })}

                  {/* BOTONES intactos */}
                  <Grid
                    item
                    xs={12}
                    md={12}
                    textAlign="center"
                    sx={{
                      mt: "10px",
                      display: "flex",
                      gap: "5px",
                      justifyContent: "center",
                    }}
                  >
                    <CustomButtonPlusIcon
                      icon={Search}
                      text="BUSCAR"
                      handleFunction={() => setSearch(!search)}
                      position="start"
                      variant="outlined"
                    />
                    <CustomButtonPlusIcon
                      icon={CleaningServices}
                      text="LIMPIAR FILTROS"
                      handleFunction={handleFilterStates}
                      position="start"
                      variant="outlined"
                      color="error"
                    />
                  </Grid>
                </Grid>
              </Collapse>

              {/* BOTÓN FLOTANTE */}
              <Box
                sx={{
                  position: "absolute",
                  bottom: showFilters ? "-26px" : "-16px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  zIndex: 10,
                }}
              >
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => setShowFilters(!showFilters)}
                  endIcon={
                    showFilters ? <KeyboardArrowUp /> : <KeyboardArrowDown />
                  }
                  sx={{
                    minWidth: "220px",
                    height: "25px",
                    borderRadius: "0px 0px 10px 10px",
                    boxShadow: 3,
                    textTransform: "none",
                    fontWeight: 500,
                  }}
                >
                  {showFilters ? "Ocultar filtros" : "Mostrar filtros"}
                </Button>
              </Box>
            </Box>
          )}

          <div style={{ position: "relative" }}>
            {flag && <LoadingPage isLoading={true} heightProp={"60vh"} />}

            {!flag && hasPermission && (
              <Table
                // selectableRowsComponent={Checkbox}

                view={"contacto"}
                apiRoute={"contacts"}
                viewTitle={"contactos"}
                viewPermission={"contacts"}
                /// data
                columns={columns}
                data={contact}
                // table sort
                onSort={handleSort}
                sortColumn={sortColumn}
                sortDirection={sortDirection}
                // table properties
                checkBoxFlag
                totalPagesNumber={totalPagesNumber}
                onSelectedRowsChange={setSelectedRowIds} // gestion de selección de contactos
                setChangeDone={setChangeDone}
                changeDone={changeDone}
                setSelectedRows={(rows) => {
                  const nextIds = normalizeSelectedContactIds(rows);
                  setSelectedRowIds((prev) => {
                    const sameSelection =
                      prev.length === nextIds.length &&
                      prev.every((id, index) => id === nextIds[index]);

                    return sameSelection ? prev : nextIds;
                  });
                }}
                icon={PersonAdd}
                selectionActions={ChangeStatusBlock}
                // table properties
                onPageChange={handlePageClick}
                pageCount={flagToChangeStateHidePaginator ? 0 : pageCount}
                forcePage={pagePressed - 1} // Esto sincroniza el botón activo
                objPerPage={objPerPage}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contactos;
